import jhsfBookingsApi from '../apis/jhsfBookingsApi';

const deleteFeaturesService = async (featureId: string): Promise<void> => {
  await jhsfBookingsApi.delete(`/features/${featureId}`);
};

export default deleteFeaturesService;
